import React from 'react';

const WaveBg = ({ color = '#ffffff', flip = false }) => {
  return (
    <div className="absolute z-0 wave-background left-0 w-full">
      <svg 
        viewBox="0 0 1440 120" 
        className="w-full h-[30vh]"
        preserveAspectRatio="none"
        style={{ transform: flip ? 'scaleX(-1)' : 'none' }}
      >
        <path 
          fill={color}
          d="M0,40 Q360,80 720,40 T1440,40 L1440,120 L0,120 Z"
        />
      </svg>
    </div>
  );
}

export default WaveBg;